import { OuterContentItem } from "@certn/cascadia-react";
import { ArrayControlProps } from "@jsonforms/core";

export function ReferenceCheckSummaryControl(props: ArrayControlProps) {
  return (
    <>
      {props.data?.map((referee: any, index: number) => (
        <OuterContentItem
          key={index}
          title={referee.referee_name}
          subtitle={referee.email}
          testID={`referee-summary-${index + 1}`}
        />
      ))}
    </>
  );
}
